import React from 'react';
import DOMPurify from 'dompurify';
import Collapsible from 'react-collapsible';
import { motion } from 'motion/react';
import { LoadingOutlined } from '@ant-design/icons';
import { Flex } from '@/components';

export interface LoginAnnouncementsProps {
  loading?: boolean;
  announcements?: AnnouncementEntity[];
}

export const LoginAnnouncements: React.FC<LoginAnnouncementsProps> = ({
  announcements = [],
  loading = false,
}) => {

  return (
    <motion.div
      initial={{ opacity: 0, x: '-200px' }}
      animate={{ opacity: 1, x: '0' }}
      exit={{ opacity: 0, x: '-200px' }}
      transition={{ duration: '0.25', bounce: false }}
      className="login-announcements-container">
      {(loading || announcements.length === 0) ?
        (
          <Flex className="w-full" justify="center" align="center">
            <Flex inlineFlex direction="column" className="text-white">
              {loading ?
                <>
                  <LoadingOutlined style={{ fontSize: 24 }} spin />
                  <b>در حال دریافت اطلاعات</b>
                </>
                :
                <b>اطلاعیه‌ای یافت نشد</b>
              }
            </Flex>
          </Flex>
        ) : (
          <Flex className="login-announcements-list" direction="column" gap="1rem">
            {announcements.map((item, i) => (
              <Flex key={i} direction="row" className="announcement-item">
                <Collapsible
                  transitionTime={300}
                  trigger={(
                    <div className="flex flex-row items-center w-full">
                      <b>{item.title}</b>
                      <span className="ms-auto">+</span>
                    </div>
                  )}
                >
                  <Flex className="pt-3" direction="column" gap="0.5rem">
                    <div className="w-full" dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.mainText, { ALLOWED_TAGS: ['b', 'a', 'i'] })
                    }}></div>
                  </Flex>
                </Collapsible>
              </Flex>
            ))}
          </Flex>
        )}

    </motion.div>
  );
};

export default LoginAnnouncements;
